import React from 'react';
import TextArea from '@bufferapp/ui/TextArea';

import { useAppSelector, useAppDispatch } from '~/store';
import { selectGeneratedIdeas } from '~/ai/state/contentIdeation/slice';
import { generateIdeas } from '~/ai/state/contentIdeation/thunks';
import { ErrorMessage } from '~/ai/components/GenerateIdeasButton/ErrorMessage';
import {
  getPrompt,
  setPromptSettings,
  getPromptSettings,
} from '~/ai/helpers/localStorage';

import * as Styled from './styles';
import { IdeaWrapper } from '../GeneratedIdea/styles';

/**
 *
 */
const Questions = () => {
  const [about, setAbout] = React.useState<string>('');
  const [targetAudience, setTargetAudience] = React.useState<string>('');

  const dispatch = useAppDispatch();

  const { generateIdeasLoading, generateIdeasError } = useAppSelector((state) =>
    selectGeneratedIdeas(state)
  );

  const onChangeAbout = (event) => {
    setAbout(event.target.value);
  };

  const onChangeTargetAudience = (event) => {
    setTargetAudience(event.target.value);
  };

  const onGenerateIdea = () => {
    dispatch(
      generateIdeas({
        prompt: getPrompt(),
        cta: 'publish-ideas-contentIdeationWidget-generate-1',
      })
    );
  };

  const onSubmit = (event) => {
    event.preventDefault();

    if (!about || !targetAudience) return;
    setPromptSettings({ about, targetAudience });
    onGenerateIdea();
  };

  React.useEffect(() => {
    const { about: savedAbout, targetAudience: savedTargetAudience } =
      getPromptSettings();

    if (!savedAbout || !savedTargetAudience) return;

    setAbout(savedAbout);
    setTargetAudience(savedTargetAudience);
  }, []);

  return (
    <>
      <Styled.Header>Let’s begin with a few questions 🪄</Styled.Header>
      <IdeaWrapper>
        <Styled.Form onSubmit={onSubmit}>
          <TextArea
            label="What is your business about?"
            value={about}
            placeholder="A training and fitness brand"
            onChange={onChangeAbout}
            id="business-about"
          />
          <TextArea
            label="What is your target audience?"
            value={targetAudience}
            placeholder="Busy working professionals worldwide"
            onChange={onChangeTargetAudience}
            id="business-target"
          />
          <Styled.Button
            type="submit"
            disabled={!about || !targetAudience}
            loading={generateIdeasLoading}
          >
            {generateIdeasLoading ? 'Generating…' : 'Generate Ideas'}
          </Styled.Button>
          {generateIdeasError && <ErrorMessage message={generateIdeasError} />}
        </Styled.Form>
      </IdeaWrapper>
    </>
  );
};

export { Questions };
